/* eslint-disable no-unused-vars */
/* eslint-disable no-unreachable */
/* eslint-disable react/prop-types */
/* eslint-disable react-refresh/only-export-components */
import React, {
  useEffect,
  useState,
  useRef,
  Suspense,
  useCallback,
} from "react";
import { connectApp } from "./store/app.connect";
// import { useDispatch, useSelector } from "react-redux";
// import { createMemoryHistory } from "history";
// import { createPortal } from 'react-dom';
// import { BASE_DEV_URL, CONFIG } from "./config/api.config";
import BetPlacingPopover from "./components/BetPlacingPopover/BetPlacingPopover";
import {
  clearIntervalAsync,
  setIntervalAsync,
} from "set-interval-async/dynamic";
import {
  GET_BALANCE_INTERVAL,
  ID_TOKEN,
  TOKEN_EXP,
  USER_DATA,
} from "./config/app.config";
import { BetPopoverContext } from "./context";
import { BASE_URL, CONFIG } from "./config/api.config";
// import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import LeftSideMenuDesktop from "./components/LeftSideMenuDesktop/LeftSideMenuDesktop";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import ToolbarDesktop from "./components/ToolbarDesktop/ToolbarDesktop";
import FooterDesktop from "./components/FooterDesktop/FooterDesktop";
import LoginPopUp from "./components/LoginPopUp";
import "./App.css";
import BetInfoPanel from "./components/BetInfoPanel/BetInfoPanel";
// import DefaultPage from "./pages/DefaultPage/DefaultPage";
// import SportsPage from "./pages/SportsPage/SportsPage";
// import EventPage from "./pages/EventPage/EventPage";
import { pagesInfoMapper } from "./helpers/pagesinfoMapper.helper";
import RootLoader from "./components/RootLoader/RootLoader";
import RulesPopUpSportEvents from "./components/Rules/RulesPopUpSportEvents";
import ComingSoonPopup from "./components/comingSoonPopup/ComingSoon";
import CashoutPopup from "./components/CashoutPopup/CashoutPopup";
import BottomDepositBar from "./components/BottomDepositBar/BottomDepositBar";
import WhatsappPortal from "./components/WhatsappPortal/WhatsappPortal";
import SlotsCasinoPopUp from "./components/SlotsCasinoPopup";
import TableCasinoLive from "./pages/CasinoLive/TableCasinoLive";
import RacingPage from "./pages/RacingPage/RacingPage";
import LanguagePopUp from "./components/LanguagePopUp";
import SVG_RedBell from "./assets/images/svgs/bellRed.svg?react";

const DefaultPage = React.lazy(() => import("./pages/DefaultPage/DefaultPage"));
const SportsPage = React.lazy(() => import("./pages/SportsPage/SportsPage"));
const EventPage = React.lazy(() => import("./pages/EventPage/EventPage"));
const IndianCardGamePage = React.lazy(() =>
  import("./pages/IndianCardGamePage/IndianCardGamePage")
);
const MyOpenBets = React.lazy(() => import("./pages/MyOpenBets/MyOpenBets"));
const CompletitionDetailPage = React.lazy(() =>
  import("./pages/CompetitionDetailPage/CompletitionDetailPage")
);
const RulesRegs = React.lazy(() => import("./pages/RulesRegs/RulesRegs"));
const ExclusionPolicy = React.lazy(() => import("./pages/ExclusionPolicy"));
const ResponsibleGambling = React.lazy(() =>
  import("./pages/ResponsibleGambling")
);
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));
const ChangePassword = React.lazy(() =>
  import("./pages/ChangePassword/ChangePassword")
);
const Settings = React.lazy(() => import("./pages/Settings/Settings"));
const TimeSettings = React.lazy(() =>
  import("./pages/TimeSettings/TimeSettings")
);
const CasinoLobby = React.lazy(() => import("./pages/CasinoLobby/CasinoLobby"));
const CasinoLive = React.lazy(() => import("./pages/CasinoLive/CasinoLive"));
const Transactions = React.lazy(() =>
  import("./pages/Transactions/Transactions")
);
const TransactionDetails = React.lazy(() =>
  import("./pages/TransactionDetails/TransactionDetails")
);
const Deposit = React.lazy(() => import("./pages/Deposit/Deposit"));
const Withdrawal = React.lazy(() => import("./pages/Withdrawal/Withdrawal"));
const BettingProfitAndLossPage = React.lazy(() =>
  import("./pages/BettingProfitAndLossPage/BettingProfitAndLossPage")
);
const BettingProfitAndLossDetailsPage = React.lazy(() =>
  import(
    "./pages/BettingProfitAndLoseDetailsPage/BettingProfitAndLossDetailsPage"
  )
);
const AccountStatementPage = React.lazy(() =>
  import("./pages/AccountStatementPage/AccountStatementPage")
);
const AccountStatementDetailsPage = React.lazy(() =>
  import("./pages/AccountStatementDetailsPage/AccountStatementDetailsPage")
);
const TransferStatementPage = React.lazy(() =>
  import("./pages/TransferStatementPage/TransferStatementPage")
);
const AviatorPage = React.lazy(() => import("./pages/AviatorPage/AviatorPage"));
const ElectionPage = React.lazy(() => import("./pages/Election/ElectionPage"));
const CasinoAura = React.lazy(() => import("./pages/CasinoLive/CasinoAura"));
const Bonus = React.lazy(() => import("./pages/Bonus/Bonus"));
const BonusStatementPage = React.lazy(() =>
  import("./pages/BonusStatement/BonusStatement")
);

// import { Redirect, Route, useParams } from "react-router-dom";

// const page = localStorage.getItem("page");
// const pageStack = localStorage.getItem("pageStack");

// const presetPage = localStorage.getItem("page") && localStorage.getItem("pageStack");
// const presetPageStack = presetPage && localStorage.getItem("pageStack") !== "undefined"? JSON.parse(localStorage.getItem("pageStack")) : ["/default-page"];

// const history = createMemoryHistory({
//   initialEntries: presetPageStack,
//   initialIndex: presetPageStack.length - 1
// });

function App({
  actions,
  auth,
  user,
  balance,
  // stakes,
  // authData,
  // balanceSettings,
  // menu,
  // message,
  // continueSessionModalShow,
  // balanceInformationHeight,
  // isPopUpOpenDispatch,
  // isConfirmBetPopUpOpen,
  // ruleRegulationPopup,
  // elementsParams,
  // version,
  // versionPopUp,
  // state,
  showBetPlacingPopover,
  showCashoutPopup,
  lastActivityDate,
  loginNew,
  rulesPopUp,
  language,
}) {
  const location = useLocation();
  // const [timeCounter, setTimeCounter] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  // const appRef = useRef(null);
  const refBetPopover = useRef(null);
  // const refSessionPopover = useRef(null);
  // const bonusPopUp = useSelector((state) => state.bonusPopUp.isPopUpOpen);
  // const ruleRegulationPopUp = useSelector((state) => state.ruleRegulationPopup);
  // const dispatch = useDispatch();
  const [animApp, setAnimApp] = useState(false);
  const [animAppOpen, setAnimAppOpen] = useState(false);
  const [animAppClose, setAnimAppClose] = useState(false);
  // const [renderFooter, setRenderFooter] = useState(false);
  const [pageInfo, setPageInfo] = useState(null);
  const [localPathnameNow, setLocalPathnameNow] = useState();
  const [isHovered, setIsHovered] = useState(false);
  const [isOpened, setIsOpened] = useState(false);
  const bellRef = useRef(null);
  const width = window.innerWidth;

  useEffect(() => {
    const currentUrl = window.location.href;
    if (currentUrl) {
      const url = new URL(currentUrl);
      const referCode = url.searchParams.get("ReferBy");
      const isAuth = localStorage.getItem(`${ID_TOKEN}`);

      if (!isAuth && referCode) {
        // console.log('refer code: ', referCode);

        setTimeout(() => {
          actions.setReferCode(referCode);
          actions.setLoginNew(true);
          actions.setTab(2);
        }, 500);
      }
    }
  }, [auth]);

  useEffect(() => {
    // if (stakes?.length <= 0 && auth) {
    actions.requestStakeButtons();
    // }
    actions.requestMenu();
    // actions.requestSettings();
  }, [auth]);

  // const handleLogOut = (...args) => {
  //   actions.requestLogout();
  // };

  useEffect(() => {
    try {
      const localToken = localStorage.getItem(`${ID_TOKEN}`);
      const localTokenExp = localStorage.getItem(`${TOKEN_EXP}`);
      const localUser = localStorage.getItem(`${USER_DATA}`);
      // If app has been F5ed  - get all app data again
      // Otherwise log user out
      if (localToken && localUser && localTokenExp) {
        actions.getAuthSuccess(localToken);
        actions.setUserDataSuccess(JSON.parse(localUser));
        actions.setAuthDataSuccess({ payload: { exp: localTokenExp } });
      }
      // eslint-disable-next-line no-unused-vars
    } catch (error) {
      actions.requestLogout();
    }

    actions.setBannerPopUp(true);

    setTimeout(() => {
      setAnimApp(true);
      setAnimAppOpen(true);
      setTimeout(() => {
        setAnimApp(false);
        setAnimAppClose(true);
        setAnimAppOpen(false);
      }, 20000);
    }, 6500);
  }, []);

  useEffect(() => {
    try {
      // let link = document.querySelector("link[rel~='icon']");
      // if (!link) {
      //   link = document.createElement("link");
      //   link.rel = "icon";
      //   document.getElementsByTagName("head")[0].appendChild(link);
      // }
      // link.href = CONFIG.favicon;

      // meta descriptions
      const meta = document.createElement("meta");
      if (meta) {
        meta.name = "description";
        meta.content = CONFIG.metaDescription;
        document.getElementsByTagName("head")[0].appendChild(meta);
      }

      // TITLE..
      if (document.title) {
        document.title = CONFIG.title;
      }

      // Apple-touch-icon
      const appleTouchIcon = document.createElement("link");
      appleTouchIcon.rel = "apple-touch-icon";
      appleTouchIcon.href = CONFIG.appleTouchIcon;
      document.getElementsByTagName("head")[0].appendChild(appleTouchIcon);

      //   <meta name="description" content="Lotus App" />
      //   <link rel=”mask-icon” href="%PUBLIC_URL%/logo.svg" color="#000000">
      //   <link rel="apple-touch-icon" href="%PUBLIC_URL%/logo180.png" />
      //   <link href="%PUBLIC_URL%/manifest.json" rel="manifest" />

      const manifest = document.createElement("link");
      manifest.rel = "manifest";
      manifest.href = CONFIG.manifestUrl;
      document.getElementsByTagName("head")[0].appendChild(manifest);

      // if (CONFIG.variableCss) {
      //   const loadTheme = async() => {
      //     try{
      //       const themeCSS = await import(CONFIG.variableCss);
      //     }catch(err) {}
      //   }

      //   loadTheme();
      // }

      if (CONFIG.variableCss) {
        const loadTheme = () => {
          try {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = CONFIG.variableCss; // Adjust the path if necessary
            document.head.appendChild(link);
          } catch (err) {
            console.error(err);
          }
        };

        loadTheme();
      }
    } catch (e) {
      console.log(e);
    }
  }, [CONFIG]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (bellRef.current && !bellRef.current.contains(event.target)) {
        setIsOpened(false);
      }
    }

    if (isOpened) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpened]);

  const getBalance = () => {
    actions.requestBalance().catch((e) => console.log("balance error = ", e));
  };

  const getDomainWithoutSubdomain = (url) => {
    try {
      const urlParts = new URL(url).hostname.split(".");
      return urlParts
        .slice(0)
        .slice(-(urlParts.length === 4 ? 3 : 2))
        .join(".");
    } catch (error) {
      console.log("55", error);
      return "";
    }
  };

  useEffect(() => {
    // const domainName = window.location.origin;
    const domainName = BASE_URL;
    const domainData = getDomainWithoutSubdomain(domainName);

    const data = {
      key: btoa(domainData),
    };

    actions.requestLogo(data);
  }, []);

  useEffect(() => {
    if (!auth || !user) return;
    if (!balance) getBalance();
    else {
      const timer = setIntervalAsync(async () => {
        await actions
          .requestBalance()
          .catch((e) => console.log("balance error = ", e));
      }, GET_BALANCE_INTERVAL);
      return () => clearIntervalAsync(timer);
    }
  }, [auth, balance]);

  useEffect(() => {
    if (auth) actions.requestOpenBets();
  }, [lastActivityDate, auth]);

  useEffect(() => {
    const segmant = location.pathname.split("/");
    const required = pagesInfoMapper[segmant[1]];
    if (required) {
      setPageInfo(required);
    } else {
      setPageInfo(pagesInfoMapper["default-page"]);
    }

    const queryParams = new URLSearchParams(location.search);
    const referCode = queryParams.get("referCode");

    if (referCode) {
      actions.setLoginNew(true);
      actions.setTab(2);
    }

    // console.log("location: ", referCode);
  }, [location]);

  // const handleEventTypeSuccess = (...args) => {
  //   if (!!args[0] && args[0]?.success) {
  //     actions.requestLogout();
  //   }
  // };

  const cancelBetPopover = () => {
    if (refBetPopover.current) {
      refBetPopover.current.dismiss();
    }
    setTimeout(() => {
      if (refBetPopover.current) {
        refBetPopover.current.dismiss();
      } else {
        actions.setShowBetPlacingPopover(false);
      }
    }, 100);
  };

  // useEffect(() => {
  //   setRenderFooter(true);
  // }, [location]);

  const desktopWithOnlyMainContainer =
    location.pathname === "/indian-card-games" ||
    location.pathname.includes("casino-lobby") ||
    location.pathname.includes("casino-live") ||
    location.pathname.includes("table-casino-live") ||
    location.pathname.includes("aviator") ||
    location.pathname.includes("livegames");

  const renderHeader = useCallback(() => {
    return width < 1024
      ? !location.pathname.includes("casino-live") &&
          !location.pathname.includes("table-casino-live") &&
          !location.pathname.includes("livegames")
      : true;
  }, [width, location.pathname]);

  const renderFooter = useCallback(() => {
    return (
      location.pathname === "/" || location.pathname.includes("default-page")
    );
    return width < 1024
      ? location.pathname === "/"
      : !location.pathname.includes("casino-live") &&
          !location.pathname.includes("table-casino-live") &&
          !location.pathname.includes("livegames") &&
          !location.pathname.includes("casino-lobby") &&
          !location.pathname.includes("event-page");
  }, [width, location.pathname]);
  // const renderFooter =
  // width<1024? location.pathname =='/' : true;

  // const renderFab = () => {
  //   return (
  //     <div
  //       title="WhatsAppContact"
  //       className="fixed cursor-pointer top-[calc(100dvh-64px)] left-3 z-50 flex w-max h-max items-center justify-center rounded-full  transition-all duration-500"
  //     >
  //       <div className="h-full bg-transparent mt-[-3px] ml-[-3px]">
  //         <svg
  //           width="49"
  //           height="49"
  //           viewBox="0 0 32 32"
  //           fill="none"
  //           xmlns="http://www.w3.org/2000/svg"
  //         >
  //           <path
  //             fillRule="evenodd"
  //             clipRule="evenodd"
  //             d="M16 31C23.732 31 30 24.732 30 17C30 9.26801 23.732 3 16 3C8.26801 3 2 9.26801 2 17C2 19.5109 2.661 21.8674 3.81847 23.905L2 31L9.31486 29.3038C11.3014 30.3854 13.5789 31 16 31ZM16 28.8462C22.5425 28.8462 27.8462 23.5425 27.8462 17C27.8462 10.4576 22.5425 5.15385 16 5.15385C9.45755 5.15385 4.15385 10.4576 4.15385 17C4.15385 19.5261 4.9445 21.8675 6.29184 23.7902L5.23077 27.7692L9.27993 26.7569C11.1894 28.0746 13.5046 28.8462 16 28.8462Z"
  //             fill="#BFC8D0"
  //           ></path>
  //           <path
  //             d="M28 16C28 22.6274 22.6274 28 16 28C13.4722 28 11.1269 27.2184 9.19266 25.8837L5.09091 26.9091L6.16576 22.8784C4.80092 20.9307 4 18.5589 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z"
  //             fill="url(#paint0_linear_87_7264)"
  //           ></path>
  //           <path
  //             fillRule="evenodd"
  //             clipRule="evenodd"
  //             d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 18.5109 2.661 20.8674 3.81847 22.905L2 30L9.31486 28.3038C11.3014 29.3854 13.5789 30 16 30ZM16 27.8462C22.5425 27.8462 27.8462 22.5425 27.8462 16C27.8462 9.45755 22.5425 4.15385 16 4.15385C9.45755 4.15385 4.15385 9.45755 4.15385 16C4.15385 18.5261 4.9445 20.8675 6.29184 22.7902L5.23077 26.7692L9.27993 25.7569C11.1894 27.0746 13.5046 27.8462 16 27.8462Z"
  //             fill="white"
  //           ></path>
  //           <path
  //             d="M12.5 9.49989C12.1672 8.83131 11.6565 8.8905 11.1407 8.8905C10.2188 8.8905 8.78125 9.99478 8.78125 12.05C8.78125 13.7343 9.52345 15.578 12.0244 18.3361C14.438 20.9979 17.6094 22.3748 20.2422 22.3279C22.875 22.2811 23.4167 20.0154 23.4167 19.2503C23.4167 18.9112 23.2062 18.742 23.0613 18.696C22.1641 18.2654 20.5093 17.4631 20.1328 17.3124C19.7563 17.1617 19.5597 17.3656 19.4375 17.4765C19.0961 17.8018 18.4193 18.7608 18.1875 18.9765C17.9558 19.1922 17.6103 19.083 17.4665 19.0015C16.9374 18.7892 15.5029 18.1511 14.3595 17.0426C12.9453 15.6718 12.8623 15.2001 12.5959 14.7803C12.3828 14.4444 12.5392 14.2384 12.6172 14.1483C12.9219 13.7968 13.3426 13.254 13.5313 12.9843C13.7199 12.7145 13.5702 12.305 13.4803 12.05C13.0938 10.953 12.7663 10.0347 12.5 9.49989Z"
  //             fill="white"
  //           ></path>
  //           <defs>
  //             <linearGradient
  //               id="paint0_linear_87_7264"
  //               x1="26.5"
  //               y1="7"
  //               x2="4"
  //               y2="28"
  //               gradientUnits="userSpaceOnUse"
  //             >
  //               <stop stopColor="#5BD066"></stop>
  //               <stop offset="1" stopColor="#27B43E"></stop>
  //             </linearGradient>
  //           </defs>
  //         </svg>
  //       </div>
  //     </div>
  //   );
  // };

  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        autoDisplay: false,
      },
      "google_translate_element"
    );
  };

  // Load Google Translate script
  useEffect(() => {
    const addScript = document.createElement("script");
    addScript.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;

    // Remove unwanted elements after load
    setTimeout(() => {
      document.querySelectorAll("iframe").forEach((iframe) => {
        if (iframe.id.startsWith(":")) {
          iframe.style.display = "none";
        }
      });
    }, 1000); // Wait for iframe to load before hiding
  }, []);

  // Direct language change
  const changeLanguage = (lang) => {
    if (!window.google || !window.google.translate) {
      return alert("Translator not loaded yet");
    }

    // Set language directly
    const select = document.querySelector(".goog-te-combo");
    if (select) {
      select.value = lang; // Set language code
      select.dispatchEvent(new Event("change"));
    }
  };

  useEffect(() => {
    setTimeout(() => {
      changeLanguage(language);
    }, 2000);
  }, [language]);

  useEffect(() => {
    const target = document.getElementById("otpless-login-page");

    if (!target) return;

    const observer = new MutationObserver(() => {
      if (target.children.length > 0) {
        target.classList.add("otpless-visible");
      } else {
        target.classList.remove("otpless-visible");
      }
    });

    observer.observe(target, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const container = document.getElementById("otpless-login-page");
      if (container) {
        clearInterval(interval);

        const addCloseButton = () => {
          if (document.getElementById("custom-close-btn")) return;

          const closeBtn = document.createElement("div");
          closeBtn.id = "custom-close-btn";
          closeBtn.innerText = "×";
          closeBtn.style.cssText = `
            position: absolute;
            top: 10px;
            right: 10px;
            width: 30px;
            height: 30px;
            background-color: #ff4d4f;
            color: #fff;
            font-size: 22px;
            font-weight: bold;
            border-radius: 50%;
            text-align: center;
            line-height: 30px;
            cursor: pointer;
            z-index: 99999999;
          `;

          closeBtn.onclick = () => {
            const iframe = container.querySelector("iframe");
            if (iframe) container.removeChild(iframe);

            container.innerHTML = "";
            container.removeAttribute("style");

            const parentDiv = document.getElementById(
              "otpless-login-page-parent"
            );
            if (parentDiv) {
              parentDiv.remove();
            }
          };

          container.appendChild(closeBtn);
        };

        const observer = new MutationObserver(() => {
          if (container.classList.contains("otpless-visible")) {
            addCloseButton();
          }
        });

        observer.observe(container, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (code) {
      const otplessInit = Reflect.get(window, "otplessInit");
      otplessInit?.();
    }
  }, []);

  return (
    <>
      <div id="google_translate_element" style={{ display: "none" }}></div>
      <div
        // ref={appRef}
        // onScroll={() => {
        //   setScrollPosition(appRef?.current?.scrollTop);
        //   actions.scrollPositionThunk(appRef?.current?.scrollTop);
        // }}
        className="w-full flex flex-col app-bg h-[100dvh] overflow-x-hidden overflow-y-auto"
      >
        <BetPopoverContext.Provider value={cancelBetPopover}>
          {renderHeader() && <ToolbarDesktop />}
          {/* <div className="flex flex-col  transition-all lg:pt-[110px] ease-in-out duration-100 pt-[94px]"> */}
          <div
            className={`flex flex-col app-bg  transition-all lg:pt-[110px] ease-in-out duration-100 ${pageInfo?.containerClass}`}
          >
            <div
              className={`flex items-start justify-start w-full ${
                !desktopWithOnlyMainContainer
                  ? "lg:px-12 xl:px-20 xlg:px-24"
                  : ""
              }`}
            >
              {!desktopWithOnlyMainContainer && <LeftSideMenuDesktop />}

              <Suspense fallback={<RootLoader />}>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <DefaultPage localPathnameNow={localPathnameNow} />
                    }
                  />
                  <Route
                    path="/default-page"
                    element={
                      <DefaultPage localPathnameNow={localPathnameNow} />
                    }
                  />

                  <Route
                    path="/sports-page/:sportsName/:eventTypeId"
                    element={<SportsPage localPathnameNow={localPathnameNow} />}
                  />

                  <Route
                    path="/competition-detail-page/:competitionName/:eventTypeId/:competitionId"
                    element={
                      <CompletitionDetailPage
                        localPathnameNow={localPathnameNow}
                      />
                    }
                  />

                  <Route
                    path="/event-page/:eventTypeId/:eventId/:marketId?/:matchName?"
                    element={<EventPage />}
                  />

                  <Route
                    path="/indian-card-games"
                    element={<IndianCardGamePage />}
                  />

                  <Route path="/open-bets" element={<MyOpenBets />} />

                  <Route path="rules-regulations" element={<RulesRegs />} />
                  <Route
                    path="exclusion-policy"
                    element={<ExclusionPolicy />}
                  />
                  <Route
                    path="responsible-gambling"
                    element={<ResponsibleGambling />}
                  />
                  <Route path="privacy-policy" element={<PrivacyPolicy />} />

                  <Route path="change-password" element={<ChangePassword />} />

                  <Route path="settings" element={<Settings />} />

                  <Route path="time-setting" element={<TimeSettings />} />

                  <Route path="casino-lobby/*" element={<CasinoLobby />} />

                  <Route
                    path="casino-live/:gameId/:tableId"
                    element={<CasinoLive />}
                  />
                  <Route
                    path="table-casino-live/:eventName"
                    element={<TableCasinoLive />}
                  />

                  <Route path="transactions" element={<Transactions />} />

                  <Route
                    path="transactions-details/:type/:refrenceNo"
                    element={<TransactionDetails />}
                  />

                  {/* {(CONFIG.showDeposit)&& */}
                  <Route path="/deposit" element={<Deposit />} />
                  {/* } */}

                  {CONFIG.showWithdrawal && (
                    <Route path="/withdraw" element={<Withdrawal />} />
                  )}

                  <Route
                    path="/betting-profit-loss"
                    element={<BettingProfitAndLossPage />}
                  />
                  <Route
                    path="/betting-profit-loss-details"
                    element={<BettingProfitAndLossDetailsPage />}
                  />

                  <Route
                    path="/account-statement"
                    element={<AccountStatementPage />}
                  />
                  <Route
                    path="/account-statement-details"
                    element={<AccountStatementDetailsPage />}
                  />

                  <Route
                    path="/transfer-statement"
                    element={<TransferStatementPage />}
                  />

                  <Route path="/aviator" element={<AviatorPage />} />

                  <Route
                    path="/ReferBy/:referCode"
                    element={<Navigate to="/" replace />}
                  />

                  <Route
                    path="/horse-racing"
                    element={<RacingPage localPathnameNow={localPathnameNow} />}
                  />

                  <Route
                    path="/greyhound-racing"
                    element={<RacingPage localPathnameNow={localPathnameNow} />}
                  />

                  <Route path="/election" element={<ElectionPage />} />

                  <Route
                    path="livegames/:gameId/:tableId/:marketId?"
                    element={<CasinoAura />}
                  />

                  <Route
                    path="/bonuses"
                    element={<Bonus localPathnameNow={localPathnameNow} />}
                  />

                  <Route
                    path="/bonus-statement"
                    element={
                      <BonusStatementPage localPathnameNow={localPathnameNow} />
                    }
                  />

                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>

              {width >= 1024 && !desktopWithOnlyMainContainer && (
                <BetInfoPanel />
              )}
            </div>
          </div>
        </BetPopoverContext.Provider>

        {width < 1024 &&
          CONFIG.showDeposit &&
          (location.pathname.includes("casino-live") ||
            location.pathname.includes("aviator") ||
            location.pathname.includes("table-casino-live") ||
            location.pathname.includes("livegames")) && <BottomDepositBar />}

        {location.pathname == "/" && <WhatsappPortal />}

        {renderFooter() && <FooterDesktop />}

        <LoginPopUp
          open={loginNew.open}
          onDidDismiss={() => {
            actions.setLoginNew(false);
          }}
        />

        <LanguagePopUp
          open={loginNew.isLanguage}
          onDidDismiss={() => {
            actions.setIsLangauage(false);
          }}
        />

        <RulesPopUpSportEvents
          open={rulesPopUp}
          // onDidDismiss={closeRuleRegulationPopup}
          scrollPosition={scrollPosition}
        />

        {width < 1024 && showBetPlacingPopover && (
          <BetPlacingPopover
            cancel={cancelBetPopover}
            refBetPopover={refBetPopover}
            open={showBetPlacingPopover}
          />
        )}

        <ComingSoonPopup />
        {showCashoutPopup && <CashoutPopup />}

        <SlotsCasinoPopUp />
        {/* {width < 1024 && showBetPlacingPopover ? (
          <BetPlacingPopover
            cancel={cancelBetPopover}
            refBetPopover={refBetPopover}
            open={showBetPlacingPopover}
          />
        ) : (
          <ConfirmBetPopUp
            cancel={cancelBetPopover}
            refBetPopover={refBetPopover}
            open={showBetPlacingPopover}
          />
        )} */}

        {/* <BetPopoverContext.Provider value={cancelBetPopover}>
          <BrowserRouter history={history}>

            <div className="flex flex-col  transition-all lg:pt-[110px] ease-in-out duration-100 pt-[94px]">
              <Routes>
                <Route
                  exact
                  path="/default-page"
                  render={() =>
                    authRender(
                      <DefaultPage localPathnameNow={localPathnameNow} />
                    )
                  }
                />
                <Redirect to="/default-page" />
              </Routes>
            </div>
          </BrowserRouter>
        </BetPopoverContext.Provider> */}
      </div>

      <div
        id="onesignal-bell-container"
        className="onesignal-bell-container onesignal-reset onesignal-bell-container-bottom-right"
      >
        <div
          ref={bellRef}
          id="onesignal-bell-launcher"
          className={`
            onesignal-bell-launcher 
            onesignal-bell-launcher-bottom-right 
            onesignal-bell-launcher-theme-default 
            onesignal-bell-launcher-active 
            onesignal-bell-launcher-${isHovered || isOpened ? "" : "in"}active 
            ${
              isHovered || isOpened
                ? "onesignal-bell-launcher-md"
                : "onesignal-bell-launcher-sm"
            }`}
          style={{ bottom: 20, right: 14 }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => setIsOpened(true)}
        >
          <div className="onesignal-bell-launcher-button">
            <SVG_RedBell />
            <div
              className="pulse-ring"
              style={{ borderColor: "var(--icon-color-secondary)" }}
            ></div>
          </div>
          <div
            className="onesignal-bell-launcher-badge"
            style={{
              background: "var(--icon-color-brand-primary",
              borderColor: "var(--icon-color-brand-primary)",
              color: "var(--icon-color-secondary)",
            }}
          ></div>
          <div
            className={`onesignal-bell-launcher-message ${
              isHovered && !isOpened && "onesignal-bell-launcher-message-opened"
            }`}
          >
            <div className="onesignal-bell-launcher-message-body">
              You&apos;ve blocked notifications
            </div>
          </div>
          <div
            className={`onesignal-bell-launcher-dialog ${
              isOpened && "onesignal-bell-launcher-dialog-opened"
            }`}
            style={{
              filter: "drop-shadow(0px 2px 2px rgba(34, 36, 38, 0.15))",
              WebkitFilter: "drop-shadow(0px 2px 2px rgba(34, 36, 38, 0.15))",
            }}
          >
            <div className="onesignal-bell-launcher-dialog-body">
              <h1>Unblock Notifications</h1>
              <div className="divider"></div>
              <div className="instructions">
                <p>Follow these instructions to allow notifications:</p>
                <a
                  href="https://media.onesignal.com/web-sdk/bell/chrome-unblock.jpg"
                  target="_blank"
                >
                  <img src="https://media.onesignal.com/web-sdk/bell/chrome-unblock.jpg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="otpless-login-page"></div>
    </>
  );
}

export default connectApp()(App);
